import type { CalendarMoreShipment } from '../../types';

const toNonEmptyText = (value: unknown): string | null => {
  const normalized = String(value ?? '').trim();
  return normalized.length > 0 ? normalized : null;
};

export const getCalendarCustomerReference = (
  shipment: CalendarMoreShipment
): string => {
  return (
    toNonEmptyText(shipment.reference_number) ||
    toNonEmptyText(shipment.link_code) ||
    toNonEmptyText(shipment.shipment_id) ||
    toNonEmptyText(shipment.id) ||
    'Unknown'
  );
};
